import React from 'react';
import { Textfit } from 'react-textfit';

const AutoFitText = ({ children, className = '', min = 10, max = 300 }) => (
  <Textfit mode="single" forceSingleModeWidth min={min} max={max} className={className}>
    {children}
  </Textfit>
);

export default AutoFitText;


